import { render, staticRenderFns } from "./summarize.vue?vue&type=template&id=a22a840a&scoped=true&"
import script from "./summarize.vue?vue&type=script&lang=js&"
export * from "./summarize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22a840a",
  null
  
)

export default component.exports